<template>
  <div id="testimonials" class="container">
        <div id="testimonials-carousel" class="carousel slide" data-ride="false">
            <div class="carousel-inner">
            <!-- Carousel-1 -->
                <div class="carousel-item active">
                    <div class="testimonial d-flex align-items-center flex-column">
                        <h4> “Anna is one of the fastest learning professionals I've worked with in my career. She has a good personality, making working together very easy.“</h4>
                        <em> <strong>Thiago Victorino.</strong> Senior Full Stack Engineer</em>
                    </div>
                </div>
            <!-- Carousel-2 -->
                <div class="carousel-item">
                    <div class="testimonial d-flex align-items-center flex-column">
                        <h4> “Anna is an amazing person, always looking to improve and give her best in the tasks she is doing. Anna will be an amazing addition to your team.“</h4>
                        <em> <strong>Guilherme Fischer.</strong> Senior Software Developer</em>
                    </div>
                </div>
            <!-- Carousel-3 -->
                <div class="carousel-item">
                    <div class="testimonial d-flex align-items-center flex-column">
                        <h4> “Anna provided us with multiple versions of our graphical design and involved us actively in the design process - she was a pleasure to work with.“</h4>
                        <em> <strong>Kai Saksela.</strong> CEO, Noiseless Acoustics Ltd</em>
                    </div>
                </div>
            <!-- Carousel-4 -->
                <div class="carousel-item">
                    <div class="testimonial d-flex align-items-center flex-column">
                        <h4>“Skuratova conducted her work conscientiously and within the agreed schedule. She showed excellent creativity and ideation skills.“</h4>
                        <em> <strong>Anne Paasi.</strong> Communications Director, University of Turku</em>
                    </div>
                </div>
            <!-- Carousel-5 -->
                <div class="carousel-item">
                    <div class="testimonial d-flex align-items-center flex-column">
                        <h4>“Anna has demonstrated an ability to be creative in the activities she plans, and open to suggestions from both children and other staff.“</h4>
                        <em> <strong>Emily Aitchison.</strong> Kindergarten Manager, Bumblebees Kindergarten Herttoniemi</em>
                    </div>
                </div>
            </div>
            <!-- Carousel-buttons -->
            <a class="carousel-control-prev" href="#testimonials-carousel" role="button" data-slide="prev">
                <span class="carousel-control-prev-icon" aria-hidden="true"></span>
                <span class="sr-only">Previous</span>
            </a>
            <a class="carousel-control-next" href="#testimonials-carousel" role="button" data-slide="next">
                <span class="carousel-control-next-icon" aria-hidden="true"></span>
                <span class="sr-only">Next</span>
            </a>
        </div>

  </div>
</template>



<script>
export default {
    name:'Testimonials'
}
</script>



<style>
#testimonials {
    padding: 80px 0 100px;
}
.testimonial h4 {
    line-height: 1.5;
    padding: 0 7rem 3rem 7rem;
    width: 70%;
}
.carousel-control-prev-icon {
    background-image: url("data:image/svg+xml;charset=utf8,%3Csvg xmlns='http://www.w3.org/2000/svg' fill='%23F3A822' viewBox='0 0 8 8'%3E%3Cpath d='M5.25 0l-4 4 4 4 1.5-1.5-2.5-2.5 2.5-2.5-1.5-1.5z'/%3E%3C/svg%3E") !important;
}
.carousel-control-next-icon {
     background-image: url("data:image/svg+xml;charset=utf8,%3Csvg xmlns='http://www.w3.org/2000/svg' fill='%23F3A822' viewBox='0 0 8 8'%3E%3Cpath d='M2.75 0l-1.5 1.5 2.5 2.5-2.5 2.5 1.5 1.5 4-4-4-4z'/%3E%3C/svg%3E") !important;
}

@media only screen 
and (min-device-width : 768px) and (max-device-width : 1024px) {
.testimonial h4 {
    font-size: 1.2rem;
    padding: 0 1rem 1rem 1rem;
}
.testimonial em {
    font-size: 0.9rem;
}
}
@media only screen and (max-width: 600px) {
.testimonial h4 {
    font-size: 0.8rem;
    width: 75%;
    padding: 0 1rem 1rem 1rem;
}
.testimonial em {
    font-size: 0.7rem;
    width: 60%;
}
.carousel-inner {
    height: 150px;
}
}
</style>